import focus from './focus';
import focusTrap from './focus-trap';

export default (app) => {
  app.directive('focus', focus);
  app.directive('focus-trap', focusTrap);
}
